import { Logger as CommonLogger } from '@sm/max-common';

const prefix = 'MAX-ROUTER';

export const Logger = new CommonLogger({ prefix });
